export enum ThemeOptions {
    Dark = 'light-theme',
    light = 'dark-theme',
}
